import { Component, Input } from '@angular/core';
import { Tile } from './tile';
import { TrackingContactUsService } from '../tracking/tracking-contact-us.service';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
})
export class TileComponent {
  @Input() tile: Tile;
  @Input() parentRoute: string;

  constructor(private trackingService: TrackingContactUsService) {}

  sendTrackingTile() {
    switch (this.tile.level) {
      case 1: {
        this.trackingService.trackTile('Quel sujet voulez-vous aborder ?', this.tile.title);
        return;
      }
      case 2: {
        this.trackingService.trackTile('Très bien. Sur quoi porte votre demande ?', this.tile.title);
        return;
      }
      case 3: {
        this.trackingService.trackTile("D'accord. Et plus précisément ?", this.tile.title);
        return;
      }
      case 4: {
        this.trackingService.trackTile('On y est presque. Vous souhaitez ?', this.tile.title);
        return;
      }
    }
  }
}
